import script from "./CardItemComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CardItemComponent.vue?vue&type=script&setup=true&lang=js"

import "./CardItemComponent.vue?vue&type=style&index=0&id=a0bb23ac&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0bb23ac"]])

export default __exports__